
import useSWR from "swr"
import {API_PROJECTS} from "../constants/apiUrls"

export default function useCountStProjectTasks(projectId) {
    const {data, mutate, error} = useSWR(`${API_PROJECTS}/${projectId}/history/count`)
    return {
        countStProjectTasks: data,
        mutateCountStProjectTasks: mutate,
        isLoadingCountStProjectTasks: !error && !data,
        isErrorCountStProjectTasks: error
    }
}